import { sync, get } from 'vuex-pathify';
import { LineString, Point, Polygon } from 'ol/geom';
import { debounce } from 'lodash';
export default {
  computed: {
    isPreciseDigitizingButtonActive: sync('edit/isPreciseDigitizingButtonActive'),
    preciseNewFeatureCoordinates: sync('edit/preciseNewFeatureCoordinates'),
    preciseDigitizingEnabled() {
      return (
        this.isAdvancedDigitizingEnabled && this.isPreciseDigitizingEnabled && this.advancedDigitizingPermissions > 0
      );
    },
    isPreciseDigitizingEnabled: get('admin/settingsValues@precise_digitizing_enabled'),
  },
  methods: {
    togglePreciseDigitizing(value, disablePushToParent = false) {
      if (value === false || this.isPreciseDigitizingButtonActive) {
        this.turnOffPreciseDigitizing(disablePushToParent);
      } else if (value === true || !this.isPreciseDigitizingButtonActive) {
        this.turnOnPreciseDigitizing(disablePushToParent);
      }
    },
    turnOffPreciseDigitizing(disablePushToParent = false) {
      this.isPreciseDigitizingButtonActive = false;
      this.$root.$emit('deleteSidebarGeometry');
      if (!disablePushToParent) this.pushToParentRoute();
      this.$root.$emit('turnOffEditing', false);
    },
    turnOnPreciseDigitizing(disablePushToParent = false) {
      this.$root.$emit('deactivateAllTools');
      this.$nextTick(() => {
        this.preciseNewFeatureCoordinates = [];
        this.isPreciseDigitizingButtonActive = true;
        if (!disablePushToParent) this.$router.push({ name: 'preciseDigitizing', params: { lid: this.layerId } });
        this.$root.$emit('drawSidebarGeometry', {
          geometryType: this.olGeometryType,
          drawendCallback: this.onDrawend,
          layerId: this.layerId,
          geometryFunction: this.getPreciseDigitizingGeometryFunction(),
        });
      });
    },

    setCurrentPreciseDigitizingCoordinates(coordinates) {
      this.preciseNewFeatureCoordinates = coordinates.filter((e, idx) => {
        return idx !== coordinates.length - 1;
      });
    },

    getPreciseDigitizingGeometryFunction() {
      return (coordinates, geometry) => {
        let currentCoordinates = [];
        if (geometry) {
          if (this.olGeometryType.includes('Polygon')) {
            if (coordinates[0].length) {
              currentCoordinates = [coordinates[0].concat([coordinates[0][0]])];
            } else {
              currentCoordinates = [];
            }
          } else {
            currentCoordinates = coordinates;
          }
          geometry.setCoordinates(currentCoordinates);
        } else {
          let Constructor;
          if (this.olGeometryType.includes('Point')) {
            Constructor = Point;
          } else if (this.olGeometryType.includes('LineString')) {
            Constructor = LineString;
          } else if (this.olGeometryType.includes('Polygon')) {
            Constructor = Polygon;
          }
          geometry = new Constructor(coordinates);
        }
        this.setCurrentPreciseDigitizingCoordinates(
          coordinates.length ? (this.olGeometryType.includes('Polygon') ? coordinates[0] : coordinates) : []
        );
        return geometry;
      };
    },
  },
  mounted() {
    this.$root.$off('togglePreciseDigitizing');
    this.$root.$on('togglePreciseDigitizing', this.togglePreciseDigitizing);
  },
  created() {
    this.setCurrentPreciseDigitizingCoordinates = debounce(this.setCurrentPreciseDigitizingCoordinates, 100);
  },
};
